import { Box, makeStyles, useTheme } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RingLoader from "react-spinners/RingLoader";
// import GptPopup from "src/components/gpt-popup";
import TransactionStatus from "src/components/other/TransactionStatus";
import { FS } from "src/configs/constance";
import useSearchParams from "src/hooks/use-search-params";
import useTravaBalance from "src/hooks/use-trava-balance";
import { fetchConfig } from "src/redux/config-slice";
import { fetchPrice } from "src/redux/price-slice";
import { getSelectedMarket, setSelectedMarket } from "src/utils";
import { initWeb3Reader } from "src/wallet-connection";
import { connectWallet, web3Modal } from "src/wallet-connection/handle-connection";
import Footer from "./Footer";
import MiniGameButton from "./Footer/MiniGameButton";
import Header from "./Header";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    background: theme.palette.background.primary,
    position: "relative",
  },
  loader: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.palette.background.primary,
  },
}));

export default function LayoutWrapper({ children }) {
  const theme = useTheme();
  const cls = useStyles();
  const dispatch = useDispatch();
  const [_, { get }] = useSearchParams();
  const { enqueueSnackbar } = useSnackbar();
  const { fetchTravaBalance } = useTravaBalance();
  const fetchingStatus = useSelector((state) => state.configSlice.fetchingStatus);
  const accountAddress = useSelector((state) => state.accountSlice.address);

  async function init() {
    await initWeb3Reader();
    if (web3Modal.cachedProvider) connectWallet(dispatch, enqueueSnackbar);
    dispatch(fetchPrice());
    dispatch(fetchConfig(enqueueSnackbar));
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const currentUrl = window.currentUrl;
    if (currentUrl) {
      if (location.pathname != currentUrl) {
        window.previousUrl = currentUrl;
        window.currentUrl = location.pathname;
      }
    } else {
      window.currentUrl = location.pathname;
      window.previousUrl = undefined;
    }
  }, [location]);

  useEffect(() => {
    if (accountAddress && fetchingStatus === FS.SUCCESS) fetchTravaBalance();
  }, [accountAddress, fetchingStatus]);

  useEffect(() => {
    const market = get("market");
    if (market && market !== getSelectedMarket()) {
      setSelectedMarket(market);
      window.location.reload();
    }
  }, []);

  return fetchingStatus != FS.SUCCESS ? (
    <Box className={cls.loader}>
      <RingLoader color={theme.palette.primary.main} size={100} />
    </Box>
  ) : (
    <Box position="relative" className={cls.root}>
      <Box>
        <Header />
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          style={{ minHeight: "calc(100vh - 20px)" }}
        >
          <Box style={{ minHeight: "calc(100vh - 60px)" }}>{children}</Box>
          <Footer />
        </Box>
      </Box>
      {/* <GptPopup /> */}
      <MiniGameButton />
      <TransactionStatus />
    </Box>
  );
}
